
import { Component, Prop, Vue } from 'vue-property-decorator'
import {
    ApplicationDeliveryType,
    EXPEDITED_PLACE_OF_ISSUES
} from '@/commons/constants/application'
import { ApplicationDocument } from '@/commons/types'

@Component
export default class ModalBoxIsExpeditedContent extends Vue {
    @Prop() deliveryTimeTranslationKey!: string
    @Prop() applicationDocument!: ApplicationDocument

    setIsExpedited (): void {
        this.applicationDocument.delivery.type = ApplicationDeliveryType.PPA_RETRIEVAL
        const selectedLocation = this.applicationDocument.delivery.location

        if (!selectedLocation || EXPEDITED_PLACE_OF_ISSUES.indexOf(selectedLocation) < 0) {
            this.applicationDocument.delivery.location = null
        }

        this.applicationDocument.expedited = true
    }
}
